export default "__VITE_ASSET__CLcGZvJx__"